import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    groups: [],
    data: {},
    range: null,
    service: null
};

export default {
    state,
    getters,
    actions,
    mutations,
    namespaced: true
}
